const o = (e) => {
  const t = encodeURIComponent(e);
  return typeof navigator < "u" && /iPad|iPhone|iPod/.test(navigator.userAgent) ? `http://maps.apple.com/?daddr=${t}` : `https://www.google.com/maps/dir/?api=1&destination=${t}`;
};
export {
  o as getMapLink
};
